export default "__VITE_ASSET__51c1fd2e__"